import React from 'react';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import { ReturnStatus } from '../../../enums/return-status';
import Global from '../../../store/global-selectors';

import { messages } from './messages';

const LabelPrintedColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { trackingInformation, returnStatus } = ret || {};
  const labelWasPrinted = trackingInformation?.trackingNumber && returnStatus !== ReturnStatus.Voided.toString();

  const date = ret.createdDateTime;

  return (
    <IconMessageColumn
      date={date}
      icon={faTag}
      message={<FormattedMessage {...messages.printed} />}
      state={labelWasPrinted ? 'normal' : 'empty'}
      tooltipMessage={<FormattedMessage {...messages.labelPrinted} />}
    />
  );
};

export const LabelPrinted = {
  getMessageDescriptor: () => messages.labelPrinted,
  id: 'label-printed',

  render: ({ fulfillmentId }) => {
    return <LabelPrintedColumn fulfillmentId={fulfillmentId} />;
  },
};
